import {
  Modal,
  Skeleton,
  Form,
  Input,
  InputNumber,
  Select,
  Radio,
  RadioChangeEvent,
  Card,
} from "antd";
import { formStyle, layout, Title } from "../styles";

import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useError } from "../../../uteis/mensagens/useError";
import { useSuccess } from "../../../uteis/mensagens/useSuccess";
import { Empreendimento } from "../../../interfaces/Empreendimento";
import { filterOption, filterSort } from "../../../uteis/filtroSelect";
import { Cidade } from "../../../interfaces/Cidade";
import { useCidade } from "../hooks/useCidade";
import { useEstado } from "../hooks/useEstado";
import { Estado } from "../../../interfaces/Estado";
import { useCadastrarEmpreendimento } from "../hooks/useCadastrarEmpreendimento";

export default function ModalEmpreendimento({
  isModalOpen,
  handleFechar,
}: any) {
  const [formEmp] = Form.useForm();

  // Referencia de edição
  const changing = useRef<boolean>(false);

  const [estadoSelecionado, setEstadoSelecionado] = useState<
    number | null | undefined
  >(null);

  const { estados } = useEstado(isModalOpen);

  const { isLoading, cidades } = useCidade(isModalOpen, estadoSelecionado);

  const {
    cadastrarEmpreendimento,
    isLoading: cadastrarLoading,
    error,
    success,
  } = useCadastrarEmpreendimento();

  // Estado inicial de Empreendimento
  const [empreendimento, setEmpreendimento] = useState<Empreendimento>({});

  const [cronograma, setCronograma] = useState<number>();

  // Função que armazena os dados alterados de Empreendimento
  const empreendimentoChange = (
    changedValues: Partial<any>,
    allValues: any
  ) => {
    changing.current = true;
    if (changing.current) {
      setEmpreendimento(allValues);
    }
  };

  //Função que armazena no state o estado selecionado
  const handleEstadoChange = (value: number) => {
    setEstadoSelecionado(value); // Atualiza o estado selecionado
    formEmp.setFieldValue("cidadeId", null); // Limpa o valor do campo cidade
  };

  // Função que armazena o dado selecionado da varanda
  const cronogramaChange = (e: RadioChangeEvent) => {
    changing.current = true;
    setCronograma(e.target.value);
  };

  // Exibe a Mensagem de  Erro
  const { showError, contextHolder: errorContextHolder } = useError();

  // Exibe a Mensagem de  Erro
  const { showSuccess, contextHolder: successContextHolder } = useSuccess();

  // Estado para controlar se o erro já foi exibido
  const [errorDisplayed, setErrorDisplayed] = useState(false);

  // Estado para controlar se o sucesso já foi exibido
  const [successDisplayed, setSuccessDisplayed] = useState(false);

  // Hook de navegação do React Router
  const navigate = useNavigate();
  useEffect(() => {
    if (isModalOpen && success && !successDisplayed) {
      // Mensagem de sucesso
      const msgSuccess = "Empreendimento cadastrado com sucesso!";
      showSuccess(msgSuccess);
      setSuccessDisplayed(true);

      // Limpa sucesso após 3 segundos
      setTimeout(() => {
        navigate(0);
      }, 2000);
    }

    if (isModalOpen && error && !errorDisplayed) {
      // Mensagem de erro
      let msgError = "Não foi possível cadastrar um novo empreendimento!";
      showError(msgError);
      setErrorDisplayed(true);

      // Limpa erro após 3 segundos
      setTimeout(() => {
        //setErrorDisplayed(false);
        msgError = "";
        navigate(0);
      }, 3000);
    }

    // Reset quando o modal fecha
    if (!isModalOpen) {
      setSuccessDisplayed(false);
      setErrorDisplayed(false);
    }
  }, [
    isModalOpen,
    success,
    error,
    showSuccess,
    showError,
    successDisplayed,
    errorDisplayed,
    navigate,
  ]);

  return (
    <>
      <Modal
        open={isModalOpen}
        onCancel={handleFechar}
        cancelText="Cancelar"
        okText="Cadastrar"
        confirmLoading={cadastrarLoading}
        onOk={() => cadastrarEmpreendimento(empreendimento)}
        okButtonProps={{
          style: {
            backgroundColor: "#003644",
            borderColor: "#003644",
            color: "white",
          }, // Botão "Ativar" com fundo verde
        }}
        cancelButtonProps={{
          style: {
            backgroundColor: "#f44336",
            borderColor: "#f44336",
            color: "white",
          }, // Botão "Cancelar" com fundo vermelho
        }}
      >
        {isLoading && <Skeleton active />}
        {!isLoading && (
          <>
            <Card
              title={<Title>Novo Empreendimento</Title>}
              style={{
                width: "100%",
                marginTop: "20px",
                borderRadius: "10px",
                boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
              }}
            >
              <>{errorContextHolder}</>
              <>{successContextHolder}</>
              {/* Apartamento */}
              <Form
                {...layout}
                form={formEmp}
                onValuesChange={(changedValues, allValues) =>
                  empreendimentoChange(changedValues, allValues)
                }
                name="empreendimento"
                //style={formStyle}
              >
                <Form.Item
                  name={["nome"]}
                  label="Empreendimento: "
                  className="formItems"
                >
                  <Input />
                </Form.Item>

                <Form.Item
                  name={["estado"]}
                  label="Estado"
                  className="formItems"
                >
                  <Select
                    showSearch
                    className="selectCidades"
                    placeholder="Selecione o estado"
                    optionFilterProp="children"
                    filterOption={filterOption}
                    filterSort={filterSort}
                    onChange={(value) => handleEstadoChange(value)}
                  >
                    {estados.map((estado: Estado) => (
                      <Select.Option
                        key={estado.id}
                        value={estado.id}
                        label={estado.nome}
                      >
                        {estado.nome}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>

                <Form.Item
                  name={["cidadeId"]}
                  label="Cidade"
                  className="formItems"
                >
                  <Select
                    showSearch
                    className="selectCidades"
                    placeholder="Selecione a cidade"
                    optionFilterProp="children"
                    filterOption={filterOption}
                    filterSort={filterSort}
                    disabled={!estadoSelecionado}
                  >
                    {cidades.map((cidade: Cidade) => (
                      <Select.Option
                        key={cidade.id}
                        value={cidade.id}
                        label={cidade.nome}
                      >
                        {cidade.nome}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
                <Form.Item
                  name={["origem"]}
                  label="Origem"
                  className="formItems"
                >
                  <InputNumber min={0} />
                </Form.Item>
                <Form.Item
                  name={["cronograma"]}
                  label="Cronogama "
                  className="formItems"
                >
                  <Radio.Group onChange={cronogramaChange} value={cronograma}>
                    <Radio value={0}>Não</Radio>
                    <Radio value={1}>Sim</Radio>
                  </Radio.Group>
                </Form.Item>
                <Form.Item
                  name={["contato"]}
                  label="Contato"
                  className="formItems"
                >
                  <Input />
                </Form.Item>
                <Form.Item
                  name={["endereco"]}
                  label="Endereco"
                  className="formItems"
                >
                  <Input />
                </Form.Item>
                <Form.Item
                  name={["descricao"]}
                  label="Descrição"
                  className="formItems"
                >
                  <Input.TextArea />
                </Form.Item>
              </Form>
            </Card>
          </>
        )}
      </Modal>
    </>
  );
}
